import actionTypes from './actionTypes'
import config from '../../../config/config'

import { checkJapanese, executeA8Script,executeAffiliateScript } from '../../../lib'
const momentDate = require('moment');



const {
  REQUEST_CHANGEPLAN,
  RECEIVE_CHANGEPLAN,
  REQUEST_STORAGEINFO,
  RECEIVE_STORAGEINFO,
  ERROR_CHANGEPLAN
} = actionTypes

export function changePlan(token, plan) {
  return function (dispatch) {
    dispatch({type: REQUEST_CHANGEPLAN})

    const payload = {
      new_plan_name: plan
    }

    return fetch(`${config.URI}/api/v1/stripe_update_subscription`, {
      method: 'put',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && (res.status === 'success')) {
          dispatch({type: RECEIVE_CHANGEPLAN})
        } else if (res.errors) {
          dispatch({type: ERROR_CHANGEPLAN})
          console.error(res.errors)
          return
        }
      })
      .catch(e => {
        console.error(e)

      })
  }
}

export function cancelPlan(token) {
  return function (dispatch) {
    dispatch({type: REQUEST_CHANGEPLAN})

    return fetch(`${config.URI}/api/v1/stripe_cancel_subscription`, {
      method: 'get',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && (res.status === 'success')) {
          dispatch({type: RECEIVE_CHANGEPLAN})
        } else if (res.errors) {
          dispatch({type: ERROR_CHANGEPLAN})
          console.error(res.errors)
          return
        }
      })
      .catch(e => {
        console.error(e)

      })
  }
}

export function createPlan(token, payload) {
  return function (dispatch) {
    dispatch({type: REQUEST_CHANGEPLAN})
    return fetch(`${config.URI}/api/v1/stripe_create_subscription`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && (res.status === 'success')) {
          executeAffiliateScript(payload, res.data.invoice_id)

          // Checking for A8 token and token date
          const token = localStorage.getItem('a8Token');
          const tokenDate = localStorage.getItem('a8TokenDate');
          if(token && tokenDate){
            let currentDate = momentDate();
            let token_date = momentDate(parseInt(tokenDate));
            console.log("Token date:", token_date.format('DD/MM/YYYY'));
            console.log("Number of days before token added:", currentDate.diff(token_date, 'days'));
            console.log("Is token Valid:", currentDate.diff(token_date, 'days') <= 90)
            if(currentDate.diff(token_date, 'days') <= 90){
              executeA8Script(token, payload, res.data.invoice_id)
            }
          }

          dispatch({type: RECEIVE_CHANGEPLAN})
        } else if (res.errors) {
          let error_message = res.errors.payment === "payment_failed" ? 'Credit payment failed. Please enter valid card information.' : res.errors.payment;
          if (checkJapanese()) {
            error_message = res.errors.payment === "payment_failed" ? 'クレジット決済に失敗しました。有効なカード情報を入力してください'  : '何かが間違っていました。もう一度やり直してください' ;
          }

          alert(error_message);
          console.error(res.errors);
          dispatch({type: ERROR_CHANGEPLAN});
          return true;
        }
      })
      .catch(e => {
        console.error(e)
      })
  }
}

export function getStorageInfo(token) {
  return function (dispatch) {
    dispatch({type: REQUEST_STORAGEINFO})
    return fetch(`${config.URI}/api/v1/storage_info`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && (res.status === 'success')) {
          dispatch({type: RECEIVE_STORAGEINFO, storageInfo: res.data.storage_info_kb})
        } else if (res.errors) {
          dispatch({type: RECEIVE_STORAGEINFO, storageInfo: ''})
          console.error(res.errors)
        }
      })
      .catch(e => {
        console.error(e)

      })
  }
}



// WEBPACK FOOTER //
// src/routes/ManagePlans/actions/index.js